<template>
  <div v-show="show" id="preferred-login-onboard">
    <h3>Peppermill Preferred</h3>
    <p v-if="preferredRateDifference.length">Membership is free, save <strong>{{ preferredRateDifference }}</strong> on your stay!</p>
    <p v-else>Membership is free, and saves you money on your stay!</p>
    <br />
    <form :action="apiUrl" class="pepvalidate-v3 full-width signup-preferred" data-preferred-callback="BOOKING-PREFERRED-ENROLL-SUCCESS" method="post">
      <p class="full-width">Signup or login here, it's easy and only requires your email address.</p>
      <p class="full-width">
        <label>
          <span class="text">Email Address</span>
          <input class="required" data-error-msg="Please enter a valid email address." v-bind:data-regex="dataRegex" name="EMAIL" type="text" @keydown="checkKeyDown" />
        </label>
      </p>
      <p class="hidden" v-if="disclaimerCopy.length">&nbsp;</p>
      <p class="full-width disclaimer" v-if="disclaimerCopy.length">
        {{ disclaimerCopy }}
      </p>
      <p class="hidden">&nbsp;</p>
      <p class="submit-wrapper full-width">
        <input type="submit" value="SIGN UP / LOGIN NOW" @click.prevent="submitForm">
      </p>
      <input class="honey" name="alasMK43kyM3khm5km5h" type="text" value="" />
      <input name="ACTION" type="hidden" value="PEPPERMILL_PREFERRED_ENROLL" />
      <input name="LOGIN_IF_FOUND" type="hidden" value="YES" />
      <input name="FIRST_NAME" type="hidden" value="" />
      <input name="LAST_NAME" type="hidden" value="" />
    </form>
    <h2 v-show="show">OR</h2>
  </div>
</template>

<script lang="ts">
/*!
 * Copyright (C) 2019-2024, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 *		2022-06-23
 *			- <view-room-details-preferred-onboard-form> now waits for DOMContentReady before initializing the form.
 *
 *		2024-06-10 (jhoward)
 *			- Implement Typescript in <view-room-details-preferred-onboard-form>.
*/

import {mapGetters, mapState} from 'vuex';
import {defineComponent} from "vue";

export default defineComponent({
  name: "view-room-details-preferred-onboard-form",
  props: {
    preferredRateDifference: {
      type: String,
      default: ''
    },
    disclaimerCopy: {
      type: String,
      default: ''
    }
  },
  mounted: function () {
    $(() => {
      if ('window.ajaxLinkRegisterCallback' in window) {
        window.ajaxLinkRegisterCallback(
            'BOOKING-PREFERRED-ENROLL-SUCCESS',
            () => {

              window.hideLoader(true, true);

              this.$emit('checkpreferred');
              this.doneWithForm = true;

              const table = document.querySelector('.view-room-details-table');
              const header = document.querySelector('#header');

              if (table) {
                let scroll = window.scrollY + table.getBoundingClientRect().top;
                if (header) {
                  scroll -= header.clientHeight;
                }
                window.scrollTo({
                  top: scroll,
                  behavior: 'smooth'
                });
              }

            }
        );

        window.ajaxLinkRegisterCallback(
            'BOOKING-PREFERRED-LOGIN-SUCCESS',
            () => {

              window.hideLoader(true, true);

              this.$emit('checkpreferred');
              this.doneWithForm = true;

              const table = document.querySelector('.view-room-details-table');
              const header = document.querySelector('#header');

              if (table) {
                let scroll = window.scrollY + table.getBoundingClientRect().top;
                if (header) {
                  scroll -= header.clientHeight;
                }
                window.scrollTo({
                  top: scroll,
                  behavior: 'smooth'
                });
              }

            }
        );
      }
    });
  },
  data: function () {
    return {
      doneWithForm: false,
      dataRegex: '^[^@]+@[^\.]+\..+$',
      formInitialized: false
    };
  },
  computed: {
    ...mapGetters([
        'apiUrl'
    ]),
    ...mapState([
        'showPreferredOnboardingForm'
    ]),
    show: function () {
      const output = this.$store.state.showPreferredOnboardingForm && !this.doneWithForm;
      if (output && !this.formInitialized) {
        const formNode: HTMLFormElement | null = this.$el.querySelector('.pepvalidate-v3');
        $(() => {
          if (formNode && 'pepvalidateInitForm' in window) {
            window.pepvalidateInitForm.call(formNode);
            this.formInitialized = true;
          }
        });
      }
      return output;
    }
  },
  methods: {
    submitForm: function () {
      let event;
      if(typeof(Event) === 'function') {
        event = new Event('submit');
      } else {
        event = document.createEvent('Event');
        event.initEvent('submit', true, true);
      }
      this.$el.querySelector('.pepvalidate-v3')?.dispatchEvent(event);
    },
    checkKeyDown: function (event: KeyboardEvent) {
      if (event.which === 13) {
        this.submitForm();
      }
    }
  }
})
</script>

<style scoped>

</style>